import {
  IItem,
} from "../items";
import { AbstractDocumentItemAlert } from "./AbstractDocumentItemAlert";

export abstract class AbstractInputRuleAlert<T extends IItem> extends AbstractDocumentItemAlert<T> {
  constructor(itemSetId: number, item: T, isError: boolean = false) {
    super(itemSetId, item, isError);
  }

  get kind(): string {
    return "入力規則";
  }

  get target(): string {
    return this.itemName
      ? "「" + (this.itemName ? this.itemName : "") + "」"
      : "id:" + this._detectedItem.id;
  }

  protected abstract get itemName(): string;
}
